export function isSSR() {
  try {
    var _process, _process$env;
    return Boolean(
    // In most places there is no document when running on server-side
    typeof document === 'undefined' ||
    // When SSRing editor with full cycle mode we define the document
    // Check Confluence specific environment variable
    typeof process !== 'undefined' && ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.REACT_SSR));
  } catch (e) {
    // Catch possible error that might occur and just return false
    return false;
  }
}